import {
  ActivityIndicator,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import React, { useEffect, useRef, useState } from "react";
import Svg, { Path } from "react-native-svg";
import {
  addToCart,
  setCart,
  triggerPdpAbondoned,
  updateCartProduct,
} from "appRedux/reducers/cartSlice";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { Link, router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import AIstylistButtonCop from "components/AIstylistButtonCop";
import SimilarProductButtonCop from "components/similarProductButtonCop";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Accordion from "components/Accordion";
import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import FavComp from "components/FavComp";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import GuestDownloadModal from "components/aistylist/guestDownloadModal";
import Heading from "components/Heading";
import { Helmet } from "react-helmet";
import ImageView from "../../src/image";
import ListView from "components/ListView";
import Loader from "components/Loader";
import ParentScrollView from "components/ParentScrollView";
import PdpStylistView from "components/aistylist/pdpStylistView";
import SEO from "../../src/utils/SEO.json";
import SaleComponent from "components/PLP/SaleComponent";
import SizeGuideModal from "src/components/PDP/SizeGuideModal";
import StepperButton from "components/PDP/StepperButton";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import { getProductDetailsApi } from "appRedux/reducers/homeSlice";
import { trackV2 } from "utils/Segment";
import { useCallback } from "react";
import { encodeFiltersToUrl } from "utils/filterUtils";

const MAX_CART_QTY = 10;

const ViewProduct = ({ productIdProp }) => {
  const [loader, setLoader] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [productData, setProductData] = useState();
  const [currentSize, setcurrentSize] = useState();
  const [isAllOutOfStock, setIsAllOutOfStock] = useState(false);
  const [productSizes, setProductSizes] = useState([]);
  const [itemCount, setItemCount] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [loadingQtyChange, setLoadingQtyChange] = useState(false);
  const [addToBagLoading, setAddToBagLoading] = useState(false);
  const [isAddedToBad, setIsAddedToBad] = useState(false);
  const [isOpenAskAI, setIsOpenAskAI] = useState(false);
  const [isSizeNotSelectedError, setIsSizeNotSelectedError] = useState(false);
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);

  const userProfile = useSelector((state) => state.ProfileReducer.profileData);
  const allFilters = useSelector((state) => state.FilterReducer.filters || []);
  const countrySymbol = useSelector(
    (state) => state.StoredutilsSlice.countrySymbol
  );
  const cart = useSelector((state) => state.CartReducer.cart);
  const _checkoutPopUp = useSelector(
    (state) => state.UtilsReducer._checkoutPopUp
  );

  const _slider1Ref = useRef();
  const _scrollRef = useRef();
  const _sizeGuideRef = useRef();
  const _guestDownloadModalRef = useRef();

  const _listViewRef = useRef();
  const dispatch = useDispatch();
  const local = useLocalSearchParams();
  const gender = local?.gender ?? "female";
  const rotate = useSharedValue(0);

  const productId = local?.id || productIdProp;

  const animatedStyles = useAnimatedStyle(() => ({
    transform: [{ rotateZ: `${rotate.value}deg` }],
  }));

  const designerurl = encodeFiltersToUrl(
    {
      selected: {
        2: [
          {
            title: productData?.brandName?.replaceAll("%", "*percent*") || '',
            id: Number(productData?.brandId),
            options: [],
          },
        ],
      },
      parent: [],
    },
    allFilters
  );

  const showSizeGuide = () => {
    const eventData = {
      product_id: productId,
      product_name: productData?.productName,
    };
    trackV2(ANALYTICS_EVENT_NAMES.SIZE_GUIDE_VIEWED, eventData);
    _sizeGuideRef?.current?.show();
  };

  useEffect(() => {
    let active = true;
    let timeout;
    if (productData) {
      timeout = setTimeout(() => {
        if (active) {
          const eventData = {
            productId: productId,
            productPrice: productData?.productPrice,
            productCategory: productData?.categoryName,
          };
          trackV2(ANALYTICS_EVENT_NAMES.PRODUCT_ABONDONED, eventData);
          dispatch(
            triggerPdpAbondoned({
              productId: productId,
            })
          );
        }
      }, 30000);
    }

    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [productData, productId]);

  useEffect(() => {
    if (productData) {
      const {
        categoryName = "",
        productPrice = 0,
        productName = "",
        subCategoryName = "",
      } = productData ?? {};
      const eventData = {
        product_id: productId,
        product_name: productName,
        product_price: productPrice,
        product_category: categoryName,
        product_subcategory: subCategoryName,
      };
      trackV2(ANALYTICS_EVENT_NAMES.PDP_VIEWED, eventData);
    }
  }, [
    productData,
    productData?.categoryName,
    productData?.productPrice,
    productData?.productName,
    productData?.subCategoryName,
    productId,
  ]);

  useEffect(() => {
    if (local?.size) {
    }
  }, [local?.size]);

  useEffect(() => {
    if (productId) {
      fetchProductData(productId);
    }
  }, [productId]);

  useEffect(() => {
    if (
      cart &&
      cart?.cart &&
      Array.isArray(cart?.cart) &&
      cart?.cart?.length > 0 &&
      currentSize?.name
    ) {
      let find = cart?.cart?.find(
        (o) =>
          productId == o?.product?.id && o?.productSize == currentSize?.name
      );
      if (find) {
        setItemCount(find?.quantity);
        setIsAddedToBad(true);
      } else {
        setItemCount(1);
        setIsAddedToBad(false);
      }
    } else {
      setItemCount(1);
      setIsAddedToBad(false);
    }
  }, [currentSize, cart, productId]);

  useEffect(() => {
    if (local?.size && productSizes && Array.isArray(productSizes)) {
      const size = productSizes?.find((o) => o?.name == local?.size);
      setcurrentSize(size);
    } else if (
      cart &&
      Array.isArray(cart?.cart) &&
      !currentSize &&
      productSizes &&
      Array.isArray(productSizes)
    ) {
      cart?.cart?.forEach((productItem) => {
        if (productId === productItem?.product?.id) {
          setcurrentSize({
            name: productItem?.productSize,
            available: true,
          });
        }
      });
    }
  }, [cart, productSizes, productId, local?.size]);

  const fetchProductData = useCallback(
    async (productId, userId) => {
      setLoader(true);
      try {
        const res = await dispatch(getProductDetailsApi({ productId, userId }));
        const data = res?.payload?.data?.data;
        const { productDetails } = data ?? [];
        if (!productDetails) {
          router.back();
        }
        if (
          productDetails?.productSizesV2 &&
          Array.isArray(productDetails?.productSizesV2)
        ) {
          setProductSizes(productDetails?.productSizesV2);
          if (
            productDetails?.productSizesV2?.filter((o) => o?.available)
              ?.length == 0 ||
            !productDetails?.isAvailable
          ) {
            setIsAllOutOfStock(true);
          } else {
            setIsAllOutOfStock(false);
          }
          if (productDetails?.productSizesV2?.length == 1) {
            setcurrentSize(productDetails?.productSizesV2[0]);
          }
        } else if (
          productDetails?.productSizes &&
          Array.isArray(productDetails?.productSizes)
        ) {
          setProductSizes(
            productDetails?.productSizes?.map((o) => ({
              available: productDetails?.isAvailable ? true : false,
              name: o,
            }))
          );
          if (
            productDetails?.productSizes?.length == 1 &&
            productDetails?.isAvailable
          ) {
            setcurrentSize({
              name: productDetails?.productSizes[0],
              available: true,
            });
          }
          if (!productDetails?.isAvailable) {
            setIsAllOutOfStock(true);
          } else {
            setIsAllOutOfStock(false);
          }
        }
        showSizeGuide();
        setProductData(data?.productDetails);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        console.log("err", err);
      }
    },
    [dispatch]
  );

  const onPressMinusBtn = () => {
    if (!currentSize) {
      setIsSizeNotSelectedError(true);
      return;
    }
    const eventData = {
      product_id: productData?.productId,
      product_name: productData?.productName,
      new_quantity: itemCount - 1,
      old_quantity: itemCount,
      total_cart_value: cart?.orderSummary?.totalAmount,
    };
    trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);
    if (isAddedToBad && currentSize && itemCount > 0) {
      setLoadingQtyChange(true);
      dispatch(
        updateCartProduct({
          productId: productData?.productId,
          quantity: itemCount - 1,
          size: currentSize?.name,
        })
      )
        .then((res) => {
          setLoadingQtyChange(false);
          if (
            [200].includes(res?.payload?.status) &&
            res?.payload?.data?.cart
          ) {
            dispatch(setCart(res?.payload?.data));
          }
        })
        .catch((err) => {
          setLoadingQtyChange(false);
        });
    } else {
      setItemCount((prev) => {
        if (prev == 0) return 0;
        else return prev - 1;
      });
    }
  };

  const onPressPlusBtn = () => {
    if (!currentSize) {
      setIsSizeNotSelectedError(true);
      return;
    }
    if (isAddedToBad && currentSize && itemCount > 0) {
      const eventData = {
        product_id: productData?.productId,
        product_name: productData?.productName,
        new_quantity: itemCount + 1,
        old_quantity: itemCount,
      };
      trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);
      setLoadingQtyChange(true);
      dispatch(
        updateCartProduct({
          productId: productData?.productId,
          quantity: itemCount + 1,
          size: currentSize?.name,
        })
      )
        .then((res) => {
          setLoadingQtyChange(false);
          if (
            [200].includes(res?.payload?.status) &&
            res?.payload?.data?.cart
          ) {
            dispatch(setCart(res?.payload?.data));
          }
        })
        .catch((err) => {
          setLoadingQtyChange(false);
        });
    } else {
      setItemCount((prev) => {
        if (prev == MAX_CART_QTY) return MAX_CART_QTY;
        else return prev + 1;
      });
    }
  };

  const _renderItem = ({ item, index }) => {
    return (
      <ImageView
        alt={`${productData?.productName} | Image | ${index}`}
        resizeMode={ImageView.resizeMode.contain}
        style={{
          width: wp(484),
          height: hp(645),
        }}
        source={{ uri: item }}
      />
    );
  };

  const handleOpenAskAI = () => {
    if (!userProfile?.userId) {
      _guestDownloadModalRef?.current?.show();
      return;
    }
    setIsOpenAskAI(true);
  };

  return (
    <ParentScrollView _scrollRef={_scrollRef}>
      <Helmet>
        <meta name="description" content={productData?.productDescription} />
        <meta name="title" content={productData?.productName} />
        <meta name="keywords" content={productData?.keywords} />
        <meta name="url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />

        <meta property="og:title" content={productData?.productName} />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content={productData?.productDescription}
        />
        <meta property="og:keywords" content={productData?.keywords} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={productData?.imageUrls?.[0]} />
        <meta property="og:image:alt" content={productData?.productName} />
      </Helmet>
      <View
        style={{
          backgroundColor: "white",
          flex: 1,
          // paddingTop: spV(20),
          paddingLeft: spV(isOpenAskAI ? 20 : 140),
          paddingRight: spV(isOpenAskAI ? 10 : 140),
          // paddingHorizontal: spH(isOpenAskAI ? 20 : 140),
          // paddingBottom: spV(80),
          minHeight: spV(500),
        }}
      >
        {loader && (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <ActivityIndicator color={Colors.black} size={40} />
          </View>
        )}
        {productData && !loader && (
          <View
            style={{
              flexDirection: "row",
            }}
          >
            <View
              style={{
                width: wp(484),
                marginRight: spH(28),
                marginTop: spV(20),
              }}
            >
              <View>
                <GestureHandlerRootView>
                  <Carousel
                    loop
                    width={wp(484)}
                    height={hp(645)}
                    ref={_slider1Ref}
                    scrollEnabled={true}
                    pagingEnabled
                    data={
                      Array.isArray(productData?.imageUrls)
                        ? [...productData?.imageUrls]
                        : []
                    }
                    scrollAnimationDuration={1000}
                    renderItem={_renderItem}
                    onSnapToItem={(index) => setCurrentActiveIndex(index)}
                  />
                </GestureHandlerRootView>

                <AIstylistButtonCop
                  productId={productData?.productId}
                  productName={productData?.productName}
                  isOpenAskAI={isOpenAskAI}
                  setIsOpenAskAI={handleOpenAskAI}
                />
                <FavComp
                  productId={productData?.productId}
                  productName={productData?.productName}
                />
                <SimilarProductButtonCop
                  productId={productData?.productId}
                  productName={productData?.productName}
                />
                <TouchableOpacity
                  style={{
                    position: "absolute",
                    top: "50%",

                    left: 20,
                  }}
                  activeOpacity={0.8}
                  onPress={() => {
                    _slider1Ref?.current?.prev({
                      count: 1,
                      animated: true,
                    });
                  }}
                >
                  <Svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.3758 4L20 5.62421L11.6242 14L20 22.3758L18.3758 24L8.3758 14L18.3758 4Z"
                      fill="#212427"
                    />
                  </Svg>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: 20,
                  }}
                  activeOpacity={0.8}
                  onPress={() => {
                    try {
                      _slider1Ref?.current?.next({
                        count: 1,
                        animated: true,
                      });
                    } catch (err) {
                      console.log("err", err);
                    }
                  }}
                >
                  <Svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.62421 24L8 22.3758L16.3758 14L8 5.62421L9.62421 4L19.6242 14L9.62421 24Z"
                      fill="#212427"
                    />
                  </Svg>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: spV(10),
                }}
              >
                {productData?.imageUrls?.length > 5 && (
                  <Carousel
                    width={wp(84)}
                    height={hp(113)}
                    vertical={false}
                    style={{
                      width: wp(484),
                    }}
                    ref={_listViewRef}
                    data={[
                      ...productData?.imageUrls,
                      ...productData?.imageUrls,
                    ]}
                    renderItem={({ item, index }) => (
                      <TouchableOpacity
                        activeOpacity={0.8}
                        onPress={() => {
                          const idx = _slider1Ref?.current?.getCurrentIndex();
                          _slider1Ref?.current?.scrollTo({
                            count: index - idx,
                          });
                          setCurrentActiveIndex(index);
                        }}
                      >
                        <ImageView
                          alt={`${productData?.productName} | Image | ${index}`}
                          resizeMode={ImageView.resizeMode.contain}
                          style={{
                            width: wp(93),
                            height: hp(113),
                            borderWidth: currentActiveIndex == index ? 1 : 0,
                          }}
                          source={{ uri: item }}
                        />
                      </TouchableOpacity>
                    )}
                  />
                )}
                {productData?.imageUrls?.length <= 5 && (
                  <ListView
                    data={productData?.imageUrls}
                    keyExtractor={(item, index) =>
                      `${item?.productId?.toString()}_${index}_filter1`
                    }
                    ref={_listViewRef}
                    ItemSeparatorComponent={() => (
                      <View
                        style={{
                          height: 110,
                          width: spV(8),
                        }}
                      />
                    )}
                    horizontal={true}
                    estimatedItemSize={110}
                    renderItem={({ item, index }) => (
                      <TouchableOpacity
                        activeOpacity={0.8}
                        onPress={() => {
                          const idx = _slider1Ref?.current?.getCurrentIndex();
                          _slider1Ref?.current?.scrollTo({
                            count: index - idx,
                          });
                          setCurrentActiveIndex(index);
                        }}
                        style={
                          {
                            // backgroundColor: Colors.grey1,
                          }
                        }
                      >
                        <ImageView
                          alt={`${productData?.productName} | Image | ${index}`}
                          resizeMode={ImageView.resizeMode.contain}
                          style={{
                            width: wp(84),
                            height: hp(113),
                            borderWidth: currentActiveIndex == index ? 1 : 0,
                          }}
                          source={{ uri: item }}
                        />
                      </TouchableOpacity>
                    )}
                  />
                )}

                {productData?.imageUrls?.length > 5 && (
                  <>
                    <TouchableOpacity
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: 4,
                      }}
                      activeOpacity={0.8}
                      onPress={() => {
                        try {
                          _listViewRef?.current?.prev({
                            animated: true,
                            count: 1,
                          });
                          _slider1Ref?.current?.prev({
                            animated: true,
                            count: 1,
                          });
                        } catch (err) {}
                      }}
                    >
                      <Svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <Path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.0255 2L12 2.97452L6.97452 8L12 13.0255L11.0255 14L5.02548 8L11.0255 2Z"
                          fill="#212427"
                        />
                      </Svg>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: 4,
                      }}
                      activeOpacity={0.8}
                      onPress={() => {
                        try {
                          _listViewRef?.current?.next({
                            animated: true,
                            count: 1,
                          });
                          _slider1Ref?.current?.next({
                            animated: true,
                            count: 1,
                          });
                        } catch (err) {}
                      }}
                    >
                      <Svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <Path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.97452 14L4 13.0255L9.02548 8L4 2.97452L4.97452 2L10.9745 8L4.97452 14Z"
                          fill="#212427"
                        />
                      </Svg>
                    </TouchableOpacity>
                  </>
                )}
              </View>
            </View>
            <View
              style={{
                flex: 1,
                marginTop: spV(20),
                marginRight: spV(20),
              }}
            >
              {productData?.isPreorder && (
                <>
                  <View
                    style={{
                      paddingHorizontal: 8,
                      paddingVertical: 6,
                      borderWidth: 1,
                      borderColor: "#21242799",
                      borderRadius: 2,
                      backgroundColor: "#FFFFFF",
                      alignSelf: "flex-start",
                      marginBottom: 8,
                    }}
                  >
                    <VText
                      style={{
                        lineHeight: 8,
                        fontSize: 8,
                        fontWeight: "550",
                        letterSpacing: "3%",
                        color: "#21242799",
                      }}
                    >
                      PRE ORDER
                    </VText>
                  </View>
                  {productData?.preorderMessage && (
                    <View
                      style={{
                        marginBottom: 16,
                      }}
                    >
                      <VText
                        style={{
                          fontSize: 13,
                          fontWeight: "350",
                          color: "#21242799",
                        }}
                      >
                        {productData?.preorderMessage}
                      </VText>
                    </View>
                  )}
                </>
              )}
              <Link
                href={`/shop/new-arrivals?optionId=1&filters=${designerurl}&page=1&gender=${gender}&title=${productData?.brandName?.replaceAll(
                  "%",
                  " "
                )}`}
                activeOpacity={0.6}
                onPress={() => {}}
              >
                <Heading
                  type="h1"
                  style={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    marginBottom: spV(10),
                    fontWeight: "600",
                  }}
                  text={productData?.brandName?.toUpperCase()}
                />
              </Link>
              <Heading
                type="h2"
                style={{
                  fontSize: fp(16),
                  lineHeight: "140%",
                  fontWeight: "350",
                  marginBottom: spV(10),
                  opacity: productData?.regionAvailability === false ? 0.2 : 1,
                }}
                numberOfLines={2}
                text={productData?.productName}
              />
              {productData?.salePercentage &&
              productData?.salePercentage > 0 ? (
                <SaleComponent
                  originalPrice={productData?.originalProductPrice}
                  finalPrice={productData?.productPrice}
                  discountPercentage={productData?.salePercentage}
                  discountStyle={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "600",
                  }}
                  finalPriceStyle={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "600",
                    marginBottom: spH(20),
                  }}
                  originalPriceStyle={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "600",
                  }}
                />
              ) : (
                <VText
                  text={`${countrySymbol}${getFormatedCurrency(
                    productData?.productPrice
                  )}`}
                  style={{
                    marginBottom: spH(20),
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "bold",
                    fontWeight: "600",
                    opacity:
                      productData?.regionAvailability === false ? 0.2 : 1,
                  }}
                />
              )}
              <VText
                style={{
                  fontSize: fp(16),
                  fontWeight: "350",
                  opacity: productData?.regionAvailability === false ? 0.2 : 1,
                }}
                text={"Color"}
              />
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 8,
                  paddingLeft: productData?.productColorCode != "00000" ? 4 : 0,
                  opacity: productData?.regionAvailability === false ? 0.2 : 1,
                }}
              >
                {productData?.productColorCode &&
                  productData?.productColorCode != "00000" && (
                    <View
                      style={{
                        backgroundColor: productData?.productColorCode,
                        width: wp(20),
                        height: wp(20),
                        borderWidth: 1,
                        borderRadius: 100,
                        marginRight: spH(8),
                      }}
                    />
                  )}

                <VText
                  style={{
                    fontSize: fp(16),
                    fontWeight: "350",
                    color: "rgba(33, 36, 39, 0.6)",
                  }}
                  text={productData?.productColor}
                />
              </View>
              {productSizes && Array.isArray(productSizes) && (
                <>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: spV(20),
                      opacity:
                        productData?.regionAvailability === false ? 0.2 : 1,
                    }}
                  >
                    <VText
                      style={{
                        fontSize: fp(16),
                        fontWeight: "350",
                      }}
                      text={`Select size\n${
                        productData?.sizeSystem
                          ? `(${productData?.sizeSystem || ""})`
                          : ""
                      }`}
                    />
                    {productData?.sizeGuide &&
                      productData?.sizeGuide?.length > 0 && (
                        <TouchableOpacity
                          disabled={productData?.regionAvailability === false}
                          onPress={() => showSizeGuide()}
                        >
                          <VText
                            style={{
                              color: "#21242799",
                              textDecorationLine: "underline",
                              fontSize: fp(12),
                              fontWeight: "350",
                            }}
                            text="Show Size Guide"
                          />
                        </TouchableOpacity>
                      )}
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      flexWrap: "wrap",
                      marginTop: spV(8),
                    }}
                  >
                    {/* item?.available ? item?.name == currentSize?.name */}
                    <View
                      style={{
                        flex: 1,
                      }}
                    >
                      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                        {productSizes?.map((item, index) => {
                          return (
                            <TouchableOpacity
                              activeOpacity={1}
                              key={index}
                              disabled={
                                !item?.available ||
                                productData?.regionAvailability === false
                              }
                              onPress={() => {
                                setcurrentSize(item);
                                setIsSizeNotSelectedError(false);
                                router.setParams({ size: item?.name });
                              }}
                              style={{
                                opacity:
                                  productData?.regionAvailability === false
                                    ? 0.2
                                    : 1,
                                height: spV(40),
                                marginRight: 8,
                                minWidth: 100,
                                paddingHorizontal: 5,
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 16,
                                backgroundColor: "white",
                                borderWidth:
                                  item?.name == currentSize?.name ? 1 : 0.8,
                                borderColor:
                                  item?.name == currentSize?.name
                                    ? "#000"
                                    : item?.available
                                    ? Colors.greyBorder
                                    : "#00000029",
                              }}
                            >
                              <VText
                                style={{
                                  fontSize: 15,
                                  fontWeight: "350",
                                  color: item?.available
                                    ? "212427"
                                    : "#2124274D",
                                  textDecorationLine: item?.available
                                    ? "none"
                                    : "line-through",
                                  textDecorationStyle: "solid",
                                }}
                              >
                                {item?.name}
                              </VText>
                            </TouchableOpacity>
                          );
                        })}
                      </View>
                    </View>
                  </View>
                </>
              )}
              <View
                style={{
                  flexDirection: "row",
                  marginTop: spV(20),
                }}
              >
                <StepperButton
                  disabled={productData?.regionAvailability === false}
                  itemCount={itemCount}
                  MAX_CART_QTY={MAX_CART_QTY}
                  onPressMinusBtn={onPressMinusBtn}
                  onPressPlusBtn={onPressPlusBtn}
                  loading={loadingQtyChange}
                  isError={isSizeNotSelectedError}
                />
                <Buttons
                  text={
                    isAllOutOfStock
                      ? "Out Of Stock"
                      : isAddedToBad
                      ? "Added To Bag"
                      : "Add To Bag"
                  }
                  loading={addToBagLoading}
                  onPress={() => {
                    if (
                      !isAllOutOfStock &&
                      currentSize &&
                      itemCount > 0 &&
                      !isAddedToBad &&
                      !addToBagLoading
                    ) {
                      setAddToBagLoading(true);
                      dispatch(
                        addToCart({
                          productId: productData?.productId,
                          qty: itemCount,
                          size: currentSize?.name,
                        })
                      )
                        .then((res) => {
                          setAddToBagLoading(false);
                          if (
                            [200]?.includes(res?.payload?.status) &&
                            res?.payload?.data?.cart
                          ) {
                            const eventData = {
                              product_id: productData?.productId,
                              product_name: productData?.productName,
                              product_price: productData?.productPrice,
                              quantity: itemCount,
                              selected_size: currentSize?.name,
                              total_price:
                                productData?.productPrice * itemCount,
                            };
                            trackV2(
                              ANALYTICS_EVENT_NAMES.ADD_TO_BAG,
                              eventData
                            );
                            dispatch(setCart(res?.payload?.data));
                            _scrollRef?.current?.scrollTo({
                              x: 0,
                              y: 0,
                              animated: true,
                            });
                            const toShow = res?.payload?.data?.cart?.find(
                              (o) => {
                                if (
                                  o?.product?.id == productId &&
                                  o?.productSize == currentSize?.name
                                ) {
                                  return true;
                                }
                              }
                            );
                            _checkoutPopUp?.current?.show([toShow], true);
                          }
                        })
                        .catch((err) => {
                          setAddToBagLoading(false);
                          console.log("err", err);
                          alert("Error");
                        });
                    }
                  }}
                  disabled={productData?.regionAvailability === false}
                  containerStyle={{
                    opacity:
                      isAllOutOfStock ||
                      !currentSize ||
                      isAddedToBad ||
                      itemCount < 1 ||
                      productData?.regionAvailability === false
                        ? 0.3
                        : 1,
                    marginLeft: spH(12),
                    width: "35%",
                    height: hp(44),
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  textStyle={{
                    fontWeight: "350",
                  }}
                />
              </View>
              {isSizeNotSelectedError && (
                <VText
                  style={{
                    fontSize: fp(20),
                    color: "#FF0000",
                  }}
                  text={"Please select size first"}
                />
              )}
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderBottomWidth: 1,
                  borderColor: "rgba(33, 36, 39, 0.3)",
                  marginTop: spV(36),
                }}
                activeOpacity={0.8}
                onPress={() => {
                  setIsOpen((prev) => {
                    if (prev == true) {
                      rotate.value = withTiming(0);
                      return false;
                    } else {
                      rotate.value = withTiming(180);
                      return true;
                    }
                  });
                }}
              >
                <VText
                  style={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "600",
                    marginBottom: spV(10),
                  }}
                  text={"Product Description"}
                />
                <Animated.View style={animatedStyles}>
                  <Svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                      fill="#212427"
                    />
                  </Svg>
                </Animated.View>
              </TouchableOpacity>

              <Accordion viewKey="qwerty" isExpanded={isOpen}>
                <VText
                  style={{
                    color: "rgba(33, 36, 39, 1)",
                    marginBottom: 16,
                    marginTop: 20,
                    fontSize: fp(16),
                    fontWeight: "350",
                  }}
                >
                  <p style={{ margin: 0, padding: 0 }}>
                    {productData.productDescription}
                  </p>
                </VText>
              </Accordion>

              <TouchableOpacity
                onPress={() => {
                  if (productData?.return?.url) {
                    Linking.openURL(productData?.return?.url);
                  }
                  const eventData = {
                    product_id: productData?.productId,
                    product_name: productData?.productName,
                  };
                  trackV2(
                    ANALYTICS_EVENT_NAMES.RETURN_POLICY_CLICKED,
                    eventData
                  );
                }}
                disabled={productData?.return?.url !== "" ? false : true}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <VText
                  style={{
                    fontSize: fp(16),
                    lineHeight: "140%",
                    fontWeight: "600",
                    marginTop: spV(28),
                    marginBottom: spV(4),
                    textDecorationLine: productData?.return?.url
                      ? "underline"
                      : "nonee",
                  }}
                  text={`Return Policy`}
                />
              </TouchableOpacity>
              {!productData?.return?.url && productData?.return?.text && (
                <VText
                  style={{
                    color: "rgba(33, 36, 39, 1)",
                    // marginBottom: 16,
                    fontSize: fp(16),
                    fontWeight: "350",
                  }}
                  text={productData?.return?.text}
                />
              )}
            </View>
            {isOpenAskAI && (
              <View
                style={{ boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)" }}
              >
                <PdpStylistView
                  productData={productData}
                  isOpenAskAI={isOpenAskAI}
                  setIsOpenAskAI={setIsOpenAskAI}
                />
              </View>
            )}

            <SizeGuideModal
              currentSize={currentSize}
              setCurrentSize={setcurrentSize}
              ref={_sizeGuideRef}
              productData={productData}
            />
          </View>
        )}

        <Loader loading={modalLoading} />
        <GuestDownloadModal ref={_guestDownloadModalRef} />
      </View>
    </ParentScrollView>
  );
};

export async function getServerSideProps(context) {
  const seoData = SEO.pages["product"];

  return {
    props: {
      dynamicTitle: seoData.title,
      dynamicDescription: seoData.description,
      dynamicKeywords: seoData.keywords,
    },
  };
}

export default ViewProduct;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    width: "100%",
    paddingBottom: 16,
  },
  dotStyle: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 0,
    backgroundColor: "rgba(0, 0, 0, 0.92)",
  },
  subitleStyle: {
    color: Colors.black60,
    marginTop: 4,
    marginBottom: 16,
  },
  titleStyle: {
    marginTop: 4,
  },
  policyView: {
    justifyContent: "space-between",
    flexDirection: "row",
    flex: 1,
  },
});
